import { isArray } from 'util';
import { MachineGroupSection } from '../machine-group-section';

export class MachineGroupSectionBuilder {
  static fromJson(json) {
    return (json)
      ? new MachineGroupSection(
        json.hash,
        json.name,
        json.models
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(MachineGroupSectionBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/machine-group-section.builder.ts